<template>
    <div class="elle-headline" :class="[style]">
        <div v-show="settings?.label" class="page-label">{{ settings.label }}</div>
        <h3 v-show="settings?.headline" class="page-headline" :class="[headlineType]" v-html="nl2br(props.settings.headline)" />
        <slot name="additional" />
    </div>
</template>

<script setup lang="ts">
const props = defineProps({
    settings: {
        type: Object,
        default: () => ({})
    },
    style: {
        type: String,
        default: ''
    },
    headlineType: {
        type: String,
        default: ''
    }
});
</script>
